import type { BtlApplication } from 'api/btlApplicationForm/types';
import { useSearchParams } from 'react-router-dom';
import { CaseApplicantIndividualPage } from './CaseApplicantIndividualPage';
import { CaseApplicantsList } from './CaseApplicantsList';

interface CaseApplicantsPageProps {
  case?: BtlApplication;
  isCaseLoading: boolean;
}

export function CaseApplicantsPage({ case: caseData, isCaseLoading }: CaseApplicantsPageProps) {
  const [searchParams] = useSearchParams();
  const individualId = searchParams.get('individualId');

  if (individualId) {
    return <CaseApplicantIndividualPage case={caseData} isCaseLoading={isCaseLoading} individualId={individualId} />;
  }

  return <CaseApplicantsList case={caseData} isCaseLoading={isCaseLoading} />;
}
